// https://observablehq.com/@mbostock/tadpoles
class Bubbles {

	constructor() {
		this.width = window.innerWidth
		|| document.documentElement.clientWidth
		|| document.body.clientWidth;

		this.height = window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight;


		let n = 8;
		let v = .4;
		let m = 12;
		let canvas = document.getElementById('canvas');
		canvas.setAttribute('width', this.width)
		canvas.setAttribute('height', this.height)

		this.context = canvas.getContext('2d');

		this.tadpoles = new Array(n).fill().map(() => ({
			vx: (Math.random()) * v,
			vy: (-Math.random()) * v,
			px: new Array(m).fill(Math.random() * this.width),
			py: new Array(m).fill(Math.random() * this.height),
			count: 0,
			innerSize: Math.random() * 4
		}));

		setInterval(() => this.draw(), 10);

	} 

	draw() {
		this.context.clearRect(0, 0, this.width, this.height);
		
		for (const t of this.tadpoles) {
			let dx = t.vx;
			let dy = t.vy;
			let x = t.px[0] += dx;
			let y = t.py[0] += dy;
			let speed = Math.sqrt(dx * dx + dy * dy);
			const count = speed * 10;
			const k1 = -5 - speed / 8;

			// Bounce off the walls.
			if (x < 0 || x > this.width) t.px[0] = 0;
			if (y < -10 || y > this.height) t.py[0] = this.height;

			// circle
			this.context.save();
			this.context.translate(t.px[0], t.py[0]);
			this.context.rotate(Math.atan2(t.vy, t.vx));
			this.context.beginPath();
			this.context.fillStyle = "#EE39EF";
			this.context.ellipse(0, 0, 8, 8, 0, 0, 2 * Math.PI);
			this.context.fill();

			// inner circle
			this.context.beginPath();
			this.context.fillStyle = "#FFF";
			this.context.ellipse(0, 0, t.innerSize, t.innerSize, 0, 0, 2 * Math.PI);
			this.context.fill();
			this.context.restore();
		}
	}
}

export default Bubbles;